import {Observable} from 'rxjs';
import {List} from 'immutable';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as BillPayerObservables from 'web-app/react/entities/bill-payers/epics';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import {EntityTypes} from 'web-app/react/entities/global-search/model';
import * as GlobalSearchApi from 'web-app/react/entities/global-search/api';

import * as Actions from './actions';
import * as Api from './api';

const updateSimple = action$ =>
    action$.ofType(Actions.updateSimple.type).mergeMap(({payload}) => {
        const {institutionId, billPayer, relationIds} = payload;

        const updatedBillPayer = billPayer.merge({
            relationsIds: billPayer.relationBundles.flatMap(bundle => bundle.ids).concat(relationIds),
        });

        return BillPayerObservables.updateObservable(institutionId, updatedBillPayer)
            .flatMap(successAction =>
                List([
                    successAction,
                    Actions.updateSimpleSuccess.action(),
                    GlobalEventActions.updateSuccess.action(i18next.t('billPayer.connectContactToBillPayerSuccess')),
                ]),
            )
            .catch(e => Observable.of(Actions.updateSimpleFailed.action(e)));
    });

const searchRelation = action$ =>
    action$
        .ofType(Actions.searchRelation.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            if (payload.term) {
                return GlobalSearchApi.search(payload.term, [EntityTypes.Relation], [payload.institutionId])
                    .map(({searchItems}) => Actions.searchRelationSuccess.action({searchResults: searchItems}))
                    .catch(e => Observable.of(Actions.searchRelationFailed.action(e)));
            } else {
                return Observable.of(Actions.searchRelationAborted.action());
            }
        });

const fetchSuggestions = action$ =>
    action$.ofType(Actions.fetchSuggestions.type).mergeMap(({payload}) => {
        return Api.fetchSuggestions(payload.institutionId, payload.billPayerId)
            .map(result => Actions.fetchSuggestionsSuccess.action(result))
            .catch(e => Observable.of(Actions.fetchSuggestionsFailed.action(e)));
    });

export default combineEpics(searchRelation, updateSimple, fetchSuggestions);
